import React, { useEffect, useState, useRef } from "react";
import { styled, Switch, alpha, CircularProgress } from "@mui/material";
import { changeProfessionalTournamentStatus } from "../../../api/changeProfessionalTournamentStatus";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const RedSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#ef364e",
    "&:hover": {
      backgroundColor: alpha("#ef364e", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#ef364e",
  },
}));

const StatusSwitch = ({ value }) => {
  const [checked, setChecked] = useState(value.status);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.auth.token);

  const handleChange = async (e) => {
    try {
      setLoading(true);
      const data = await changeProfessionalTournamentStatus(
        value.id,
        e.target.checked,
        token
      );
      if (data.success) {
        setChecked(e.target.checked);
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error("error !!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <CircularProgress sx={{ color: "#ef364e" }} size="30px" />
      ) : (
        <RedSwitch checked={checked} onChange={handleChange} />
      )}
    </>
  );
};

export default StatusSwitch;
